import React from 'react';
import HeaderComponent from './components/header';
import MainContainer from './components/main-container';
import { useLocation } from 'react-router-dom';
import { NotificationContainer } from 'react-notifications';
import { cn } from '@/lib/utils';
import 'react-notifications/lib/notifications.css';

export default function App() {
  const pathname = (useLocation().pathname ?? '/').replace(/\/$/, '') || '/';
  const isAuthRoute = pathname === '/login' || pathname === '/signup';

  const withSideNav = !isAuthRoute;
  const withHeader = !isAuthRoute;

  return (
    <div
      className={cn(
        'bethere-bg flex min-h-screen flex-col font-sans antialiased',
        isAuthRoute && 'bethere-auth-page',
      )}
    >
      <HeaderComponent withHeader={withHeader} />
      <MainContainer withSideNav={withSideNav} />
      <NotificationContainer />
    </div>
  );
}
